import { useEffect, useState } from 'react';

import { localeTags, type AppLocale } from '../app/config';

function getClockEmoji(now: Date) {
  const hours = now.getHours();
  if (hours >= 5 && hours < 12) {
    return '🌅';
  }
  if (hours >= 18 && hours < 22) {
    return '🌆';
  }
  if (hours >= 22 || hours < 5) {
    return '🌙';
  }
  return '☀️';
}

function capitalize(value: string) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export function useClock(locale: AppLocale) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setNow(new Date());
    }, 1000);

    return () => {
      window.clearInterval(intervalId);
    };
  }, []);

  const localeTag = localeTags[locale];
  return {
    dayLabel: capitalize(
      now.toLocaleDateString(localeTag, {
        weekday: 'long',
      })
    ),
    timeLabel: `${getClockEmoji(now)} ${now.toLocaleTimeString(localeTag, {
      hour12: false,
    })}`,
  };
}
